/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCommissionStatementDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfCommissionStatementDtoFromDiscriminatorValue, serializeCommissionStatementDto, serializeCreateCommissionStatementRequest, type CommissionStatementDto, type CreateCommissionStatementRequest, type ErrorResponse, type InternalErrorResponse, type PagedResultOfCommissionStatementDto } from '../../../models/index.js';
// @ts-ignore
import { BySalesRepRequestBuilderNavigationMetadata, type BySalesRepRequestBuilder } from './bySalesRep/index.js';
// @ts-ignore
import { GenerateRequestBuilderRequestsMetadata, type GenerateRequestBuilder } from './generate/index.js';
// @ts-ignore
import { type WithCommissionStatementItemRequestBuilder, WithCommissionStatementItemRequestBuilderNavigationMetadata, WithCommissionStatementItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/statements
 */
export interface StatementsRequestBuilder extends BaseRequestBuilder<StatementsRequestBuilder> {
    /**
     * The bySalesRep property
     */
    get bySalesRep(): BySalesRepRequestBuilder;
    /**
     * The generate property
     */
    get generate(): GenerateRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.commissions.statements.item collection
     * @param commissionStatementId Unique identifier of the item
     * @returns {WithCommissionStatementItemRequestBuilder}
     */
     byCommissionStatementId(commissionStatementId: string) : WithCommissionStatementItemRequestBuilder;
    /**
     * Covers every sales rep in the organization, newest period first. Deleted statements are included: filter on `active` to leave them out, or use the by-sales-rep endpoint, which excludes them already. Filter on `status` to build a review queue — Pending for statements not yet submitted, InReview for those waiting on a decision. Each statement arrives complete, with all of its invoice entries and history, so keep the page size modest for reps with heavy invoice volume.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfCommissionStatementDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<StatementsRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfCommissionStatementDto | undefined>;
    /**
     * Runs the same calculation as the preview endpoint and keeps the result, starting it at Pending — the beginning of the review workflow, from which it is submitted for review, then approved or disputed, then marked paid. The same preconditions apply: the rep needs an active plan covering the end date, and only invoices credited to that rep, dated in the period, and carrying a payment contribute. This is not idempotent: posting the same rep and period twice produces two separate statements, each with its own identifier, so preview first and post once. The saved statement is a snapshot — later invoice payments and later edits to the plan do not change it, and nothing recalculates it in place. Successful creation answers 200, not 201.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CommissionStatementDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateCommissionStatementRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CommissionStatementDto | undefined>;
    /**
     * Covers every sales rep in the organization, newest period first. Deleted statements are included: filter on `active` to leave them out, or use the by-sales-rep endpoint, which excludes them already. Filter on `status` to build a review queue — Pending for statements not yet submitted, InReview for those waiting on a decision. Each statement arrives complete, with all of its invoice entries and history, so keep the page size modest for reps with heavy invoice volume.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<StatementsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Runs the same calculation as the preview endpoint and keeps the result, starting it at Pending — the beginning of the review workflow, from which it is submitted for review, then approved or disputed, then marked paid. The same preconditions apply: the rep needs an active plan covering the end date, and only invoices credited to that rep, dated in the period, and carrying a payment contribute. This is not idempotent: posting the same rep and period twice produces two separate statements, each with its own identifier, so preview first and post once. The saved statement is a snapshot — later invoice payments and later edits to the plan do not change it, and nothing recalculates it in place. Successful creation answers 200, not 201.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateCommissionStatementRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Covers every sales rep in the organization, newest period first. Deleted statements are included: filter on `active` to leave them out, or use the by-sales-rep endpoint, which excludes them already. Filter on `status` to build a review queue — Pending for statements not yet submitted, InReview for those waiting on a decision. Each statement arrives complete, with all of its invoice entries and history, so keep the page size modest for reps with heavy invoice volume.
 */
export interface StatementsRequestBuilderGetQueryParameters {
    filters?: string[];
    pageNumber?: number;
    pageSize?: number;
    sortDirection?: string;
    sortOn?: string;
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const StatementsRequestBuilderUriTemplate = "{+baseurl}/api/commissions/statements?pageNumber={pageNumber}&pageSize={pageSize}&sortDirection={sortDirection}&sortOn={sortOn}{&filters*,useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const StatementsRequestBuilderNavigationMetadata: Record<Exclude<keyof StatementsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCommissionStatementId: {
        requestsMetadata: WithCommissionStatementItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithCommissionStatementItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["commissionStatementId"],
    },
    bySalesRep: {
        navigationMetadata: BySalesRepRequestBuilderNavigationMetadata,
    },
    generate: {
        requestsMetadata: GenerateRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const StatementsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: StatementsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfCommissionStatementDtoFromDiscriminatorValue,
    },
    post: {
        uriTemplate: StatementsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCommissionStatementDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateCommissionStatementRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
